"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tab = exports.TabContentItem = exports.TabContent = exports.TabMenuItem = exports.TabMenu = exports.TabContainer = exports.TabPosition = void 0;
var react_1 = __importDefault(require("react"));
var TabPosition;
(function (TabPosition) {
    TabPosition["Centered"] = "+centered";
    TabPosition["Left"] = "+left";
    TabPosition["Right"] = "+right";
    TabPosition["Below"] = "+below";
})(TabPosition = exports.TabPosition || (exports.TabPosition = {}));
var TabContainer = function (_a) {
    var position = _a.position, vertical = _a.vertical, className = _a.className, props = __rest(_a, ["position", "vertical", "className"]);
    var classes = ['c-tabbed'];
    if (className)
        classes.push(className);
    if (position)
        classes.push(position);
    return (react_1.default.createElement("div", __assign({}, props, { className: classes.join(' ') })));
};
exports.TabContainer = TabContainer;
var TabMenu = function (_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    var classes = ['c-tabs'];
    if (className) {
        classes.push(className);
    }
    return (react_1.default.createElement("div", __assign({}, props, { className: classes.join(' ') })));
};
exports.TabMenu = TabMenu;
var TabMenuItem = function (_a) {
    var current = _a.current, className = _a.className, props = __rest(_a, ["current", "className"]);
    var classes = ['c-tab-item'];
    if (className) {
        classes.push(className);
    }
    if (current) {
        classes.push('+current');
    }
    return (react_1.default.createElement("div", __assign({}, props, { className: classes.join(' ') })));
};
exports.TabMenuItem = TabMenuItem;
var TabContent = function (_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    var classes = [];
    if (className) {
        classes.push(className);
    }
    return (react_1.default.createElement("div", __assign({}, props, { className: classes.join(' ') })));
};
exports.TabContent = TabContent;
var TabContentItem = function (_a) {
    var active = _a.active, className = _a.className, props = __rest(_a, ["active", "className"]);
    var classes = ['c-tab-content'];
    if (className) {
        classes.push(className);
    }
    if (active) {
        classes.push('+active');
    }
    return (react_1.default.createElement("div", __assign({}, props, { className: classes.join(' ') })));
};
exports.TabContentItem = TabContentItem;
exports.Tab = {
    Container: exports.TabContainer,
    Menu: exports.TabMenu,
    MenuItem: exports.TabMenuItem,
    Content: exports.TabContent,
    ContentItem: exports.TabContentItem,
};
//# sourceMappingURL=Tabs.js.map